import React from 'react';
import useAuth from '../../hooks/useAuth';
import AdminOverview from './AdminOverview';
import TenantOverview from './TenantOverview';

const Overview = () => {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin' || user?.type === 'admin';

  // Renderiza dashboard específico baseado no tipo de usuário
  return isAdmin ? <AdminOverview /> : <TenantOverview />;
};

export default Overview;